import { Link } from 'react-router-dom';

import styles from './Memories.module.css';
import rightChevron from './../../assets/icons/RightChevron.svg';

// Images
import PhotoAward1_1x from './../../assets/HomePage/Memories/PhotoAward1/PhotoAward1_1x.webp';
import PhotoAward1_2x from './../../assets/HomePage/Memories/PhotoAward1/PhotoAward1_2x.webp';
import PhotoAward1_M1x from './../../assets/HomePage/Memories/Mobile/PhotoAward1/PhotoAward1_1x.webp';
import PhotoAward1_M2x from './../../assets/HomePage/Memories/Mobile/PhotoAward1/PhotoAward1_2x.webp';

import PhotoAward2_1x from './../../assets/HomePage/Memories/PhotoAward2/PhotoAward2_1x.webp';
import PhotoAward2_2x from './../../assets/HomePage/Memories/PhotoAward2/PhotoAward2_2x.webp';
import PhotoAward2_M1x from './../../assets/HomePage/Memories/Mobile/PhotoAward2/PhotoAward2_1x.webp';
import PhotoAward2_M2x from './../../assets/HomePage/Memories/Mobile/PhotoAward2/PhotoAward2_2x.webp';

import PhotoAward3_1x from './../../assets/HomePage/Memories/PhotoAward3/PhotoAward3_1x.webp';
import PhotoAward3_2x from './../../assets/HomePage/Memories/PhotoAward3/PhotoAward3_2x.webp';
import PhotoAward3_M1x from './../../assets/HomePage/Memories/Mobile/PhotoAward3/PhotoAward3_1x.webp';
import PhotoAward3_M2x from './../../assets/HomePage/Memories/Mobile/PhotoAward3/PhotoAward3_2x.webp';

import PhotoAward4_1x from './../../assets/HomePage/Memories/PhotoAward4/PhotoAward4_1x.webp';
import PhotoAward4_2x from './../../assets/HomePage/Memories/PhotoAward4/PhotoAward4_2x.webp';
import PhotoAward4_M1x from './../../assets/HomePage/Memories/Mobile/PhotoAward4/PhotoAward4_1x.webp';
import PhotoAward4_M2x from './../../assets/HomePage/Memories/Mobile/PhotoAward4/PhotoAward4_2x.webp';

import PhotoAward5_1x from './../../assets/HomePage/Memories/PhotoAward5/PhotoAward5_1x.webp';
import PhotoAward5_2x from './../../assets/HomePage/Memories/PhotoAward5/PhotoAward5_2x.webp';
import PhotoAward5_M1x from './../../assets/HomePage/Memories/Mobile/PhotoAward5/PhotoAward5_1x.webp';
import PhotoAward5_M2x from './../../assets/HomePage/Memories/Mobile/PhotoAward5/PhotoAward5_2x.webp';


export default function MemoriesComponent() {
    const data = [
        {
            id: 1,
            image1x: PhotoAward1_1x,
            image2x: PhotoAward1_2x,
            imageM1x: PhotoAward1_M1x,
            imageM2x: PhotoAward1_M2x,
            alt: 'Jagdish Chopde Receiving Award'
        },
        {
            id: 2,
            image1x: PhotoAward2_1x,
            image2x: PhotoAward2_2x,
            imageM1x: PhotoAward2_M1x,
            imageM2x: PhotoAward2_M2x,
            alt: 'Jagdish Chopde Receiving Award'
        },
        {
            id: 3,
            image1x: PhotoAward3_1x,
            image2x: PhotoAward3_2x,
            imageM1x: PhotoAward3_M1x,
            imageM2x: PhotoAward3_M2x,
            alt: 'Jagdish Chopde Receiving Award'
        },
        {
            id: 4,
            image1x: PhotoAward4_1x,
            image2x: PhotoAward4_2x,
            imageM1x: PhotoAward4_M1x,
            imageM2x: PhotoAward4_M2x,
            alt: 'Jagdish Chopde Receiving Award'
        },
        {
            id: 5,
            image1x: PhotoAward5_1x,
            image2x: PhotoAward5_2x,
            imageM1x: PhotoAward5_M1x,
            imageM2x: PhotoAward5_M2x,
            alt: 'Jagdish Chopde Receiving Award'
        }
    ];

    return (
        <Link to="/memories" className={styles.memoriesSection + ' section'}>
            <div className={styles.cardHeader}>
                <h2 className='D_HeadingSection'>Photos of Achievements & Memories</h2>
                <span className='D_ViewAll'>VIEW ALL <img src={rightChevron} alt="Right Chevron" /></span>
            </div>
            <div className={styles.memoriesContent + ' section_content'}>
                {
                    data.map(item =>
                        <picture key={item.id}>
                            <source media="(min-width:750px)" srcSet={item.image1x + ' 1x, ' + item.image2x + ' 2x'} alt={item.alt} />
                            <source media="(min-width:300px)" srcSet={item.imageM1x + ' 1x, ' + item.imageM2x + ' 2x'} alt={item.alt} />
                            <img src={item.image1x} alt={item.alt} />
                        </picture>
                    )
                }
            </div>
        </Link >
    );
}